import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { EntityLinkCollection } from '../index'

export const setupEntityLinkReplication = (
  collection: EntityLinkCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'entitylinks',
    displayName: 'EntityLink',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      envId: doc.envId,
      sourceEntityType: doc.sourceEntityType,
      sourceEntityId: doc.sourceEntityId,
      targetEntityType: doc.targetEntityType,
      targetEntityId: doc.targetEntityId,
      linkType: doc.linkType,
      isDeleted: doc.isDeleted || false,
      // Backend types these as `string?` (nullable). Local schema requires
      // non-null with default ''; coerce here to keep RxDB validation happy
      // when a referenced entity has been soft-deleted server-side.
      sourceEntityName: doc.sourceEntityName ?? '',
      sourceEntityIcon: doc.sourceEntityIcon ?? '',
      targetEntityName: doc.targetEntityName ?? '',
      targetEntityIcon: doc.targetEntityIcon ?? '',
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      envId,
      sourceEntityType: state.sourceEntityType,
      sourceEntityId: state.sourceEntityId,
      targetEntityType: state.targetEntityType,
      targetEntityId: state.targetEntityId,
      linkType: state.linkType,
      isDeleted: state.isDeleted,
      sourceEntityName: state.sourceEntityName,
      sourceEntityIcon: state.sourceEntityIcon,
      targetEntityName: state.targetEntityName,
      targetEntityIcon: state.targetEntityIcon,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy,
    }),
  })
